export default {
    BUTTON_LEFT: 0,
    BUTTON_RIGHT: 2,
};
